import { render, staticRenderFns } from "./PageLoaderComponent.vue?vue&type=template&id=00c922cc&scoped=true"
import script from "./PageLoaderComponent.vue?vue&type=script&lang=js"
export * from "./PageLoaderComponent.vue?vue&type=script&lang=js"
import style0 from "./PageLoaderComponent.vue?vue&type=style&index=0&id=00c922cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00c922cc",
  null
  
)

export default component.exports